import {
  ServicesForBuyers,
  BaseModeration,
  SobAndAgentsServices,
  ToolsForDevelopers,
  UserExpirience,
} from './components';
import { useToScroll } from 'shared/hooks/useToScroll';

export const TechnologiesCian: React.FC = () => {
  useToScroll();

  return (
    <>
      <UserExpirience />
      <SobAndAgentsServices />
      <ServicesForBuyers />
      <BaseModeration />
      <ToolsForDevelopers />
    </>
  );
};
